module.exports = __webpack_public_path__ + "static/img/react.37fe832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/react.png
// module id = ErbA
// module chunks = 1